import {
    GETSMSPROVIDER_SUCCESS,
    GETSMSPROVIDER_FAILED,
    RESET_GETSMSPROVIDER,
    LOADING_GETSMSPROVIDER,
    NETWORK_GETSMSPROVIDER,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetSMSProvider = () => {
    return { type: RESET_GETSMSPROVIDER };
};

const getSMSProvider = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETSMSPROVIDER });
    await adminServices
        .post("getSmsProvider", userData, { headers: { AuthToken: authTokenIs } })

        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getSmsProviderSuccess(res.data));
                    break;
                default:
                    dispatch(getSmsProviderFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_GETSMSPROVIDER, payload: err });
        });
};

function getSmsProviderSuccess(data) {
    return {
        type: GETSMSPROVIDER_SUCCESS,
        payload: data,
    };
}

function getSmsProviderFailed(data) {
    return {
        type: GETSMSPROVIDER_FAILED,
        payload: data,
    };
}

export { resetGetSMSProvider, getSMSProvider };
